/* eslint-disable react-hooks/exhaustive-deps, camelcase */
import React, { useEffect } from "react"
import types from "prop-types"
import { useDispatch } from "react-redux"
import { initialize as initializeAnswerOptionsLists } from "reduxSlices/answerOptionsListsSlice"
import { initializeFormBuilderState, resetFormBuilderState } from "reduxSlices/formBuilderSlice"
import { initializeWorkflowsState } from "reduxSlices/workflowsSlice"
import { categoryFormBuilderShape } from "utils/propTypeShapes"
import withReduxProvider from "shared/withReduxProvider"
import FormBuilderTabs from "./FormBuilderTabs"

const FormBuilder = ({
  answeredQuestions,
  category,
  form,
  workflows,
}) => {
  const dispatch = useDispatch()

  // When the component mounts, store all the organization's workflows in redux
  // and load the category's public forms
  useEffect(() => {
    dispatch(initializeWorkflowsState({ categorySlug: category.slug, workflows }))
  }, [])

  useEffect(() => {
    dispatch(initializeAnswerOptionsLists({}))
  }, [])

  // When the component mounts, set up form builder data in redux.
  // IF the component unmounts before the thunk is finished, cancel.
  // See https://redux-toolkit.js.org/api/createAsyncThunk#canceling-while-running
  //
  // When the component unmounts, reset the form builder data in redux
  // to prevent components initializing with data from a previously loaded form.
  useEffect(() => {
    const promise = dispatch(initializeFormBuilderState({ answeredQuestions, category, form }))

    return () => {
      promise.abort()
      dispatch(resetFormBuilderState())
    }
  }, [])

  return (
    <div className="form-builder">
      <FormBuilderTabs />
    </div>
  )
}

FormBuilder.propTypes = {
  answeredQuestions: types.arrayOf(types.string).isRequired,
  category: categoryFormBuilderShape.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  form: types.object.isRequired,
  workflows: types.arrayOf(types.object).isRequired,
}

export default withReduxProvider(FormBuilder)
